import api from 'api/apiInstance';

export function clientInteractionReportApi(path: string) {
  return {
    path,
    DELETE: () => api.delete(path),
  };
}
